<template>
  <layout-default>
    <div class="container shop-breadcrumb border-bottom">
      <Breadcrumb class="breadcrumb" />
      <h1 class="shop-title mt-2">{{ $t('navigation.shop') }}</h1>
    </div>
    <div class="container shop-container">
      <div class="row">
        <div
          class="filter-col col-md-3 col-sm-12 pe-4 d-none d-md-block filter-mobile"
          :class="{ active: filterMenuState }"
        >
          <!-- Search -->
          <div class="filter-search-shop">
            <div>
              <FilterTitle
                class="title mb-3 mt-0"
                :title="$t('shop.searchForAuctions')"
              />
            </div>
            <div>
              <BasicInputSearch
                :value="searchQuery"
                @onInput="searchQuery = $event"
                v-model="searchQuery"
                class="list-search"
                :placeHolder="$t('shop.searchProducts')"
              />
            </div>
          </div>
          <!-- RangePrice -->
          <div class="d-flex filter-range-shop flex-column">
            <div>
              <FilterTitle class="title mb-3" :title="$t('shop.filterByPrice')" />
            </div>
            <div class="shop-slider d-block">
              <vue-slider
                v-model="rangeSliderValue"
                :process="true"
                :max="2000.0"
                :tooltip-formatter="(v) => $convertCurrency(v)"
                :contained="true"
              ></vue-slider>
              <div
                class="d-flex align-items-center justify-content-between mt-3"
              >
                <ButtonFilled
                  class="filter-btn text-white fw-bold mt-0"
                  :text="$t('common.filter')"
                  size="small"
                  :hasRoundedCorners="true"
                  @click="applyPriceRangeFilter"
                />
                <div class="price-font">
                  {{ $t('product.price') }}:<br>{{ $convertCurrency(rangeSliderValue[0]) }} -
                  {{ $convertCurrency(rangeSliderValue[1]) }}
                </div>
              </div>
            </div>
          </div>
          <!-- ColorSelect -->
          <!-- <div class="d-flex color-select-shop flex-column">
            <div>
              <FilterTitle class="title mb-3" title="Color" />
            </div>
            <div class="shop-slider">
              <BasicInputSearch
                class="input-color mb-2"
                placeHolder="Any color"
              />
              <ButtonFilled
                class="filter-btn fw-bold text-white"
                name="Apply"
                text="Apply"
                size="small"
                :hasRoundedCorners="true"
              />
            </div>
          </div> -->
          <!-- Condition -->
          <div class=" d-flex condition-select-shop flex-column">
            <div>
              <FilterTitle class="title mb-3" :title="$t('shop.condition')" />
            </div>
            <div class="shop-slider">
              <div class="condition-dropdown-wrapper d-flex">
                <BasicSelectBox
                  class=""
                  :options="conditionOptions"
                  @selected="selectedCondition = $event"
                  :defaultValueText="$t('common.all')"
                />
              </div>
              <ButtonFilled
                class="filter-btn fw-bold text-white"
                name="Apply"
                :text="$t('common.apply')"
                size="small"
                :hasRoundedCorners="true"
                @click="applyConditionFilter"
              />
            </div>
          </div>
          <!-- Brand -->
          <div class=" d-flex brand-select-shop flex-column">
            <div>
              <FilterTitle class="title mb-3" :title="$t('shop.brand')" />
            </div>
            <div class="shop-slider">
              <div class="brand-dropdown-wrapper d-flex">
                <BasicSelectBox
                  :options="brandOptions"
                  @selected="selectedBrand = $event"
                  :defaultValueText="$t('common.all')"
                />
              </div>
              <ButtonFilled
                class="filter-btn fw-bold text-white"
                name="Apply"
                :text="$t('common.apply')"
                size="small"
                :hasRoundedCorners="true"
                @click="applyBrandFilter"
              />
            </div>
          </div>
          <!-- Size -->
          <!-- <div class=" d-flex size-select-shop flex-column">
            <div>
              <FilterTitle class="title mb-3" title="Size" />
            </div>
            <div class="align-items-start">
              <FilterListSize :items="dimensions" />
            </div>
          </div> -->
          <!-- Tags -->
          <!-- <div class="d-flex tags-shop flex-column">
            <div>
              <FilterTitle class="title mb-3" title="Product tags" />
            </div>
            <div class="align-items-start">
              <FilterListTags :items="tags" />
            </div>
          </div> -->
          <!-- Product Categories -->
          <!-- <div class="d-flex categories-shop flex-column">
            <div>
              <FilterTitle class="title mb-3" title="Product categories" />
            </div>
            <div class="product-categories-list align-items-start">
              <FilterListCategoryAndSubcategories :items="categories" />
            </div>
          </div> -->
        </div>
        <div class="col-md-9 col-sm-12 shop-grid" id="topGrid">
          <div class="fluid-container filter-bar-shop">
            <filter-bar
              :totalResults="numberOfItems"
              :itemsShowing="
                currentPage * itemsPerPage > numberOfItems
                  ? numberOfItems
                  : currentPage * itemsPerPage
              "
            >
              <template v-slot:left>
                <change-layout-buttons class="me-4" @onChange='layout = !layout'></change-layout-buttons>

                <button
                  class="float-end d-block d-md-none btn-link btn text-decoration-none"
                  @click="
                    showFilterMenu = !showFilterMenu;
                    $store.commit('toggleModal', 'filter');
                  "
                >
                  <font-awesome-icon class="fa icon" :icon="['fas', 'cogs']" />
                </button>
              </template>
              <template v-slot:right>
                <div class="sorting d-flex">
                  <BasicSelectBox
                    class="orderby"
                    :options="sortOptions"
                    @selected="selectedSortOption = $event"
                    :defaultValueText="$t('shop.defaultSorting')"
                  />
                </div>
              </template>
            </filter-bar>
          </div>
          <keep-alive>
            <component
              :is="layout === true ? 'Grid' : 'List'"
              :items="products"
              :itemsPerRow="3"
            />
          </keep-alive>

          <pagination-buttons
            class="pagination-shop"
            v-if="this.totalPages > 1"
            resetID="topGrid"
            :pageNumbers="this.totalPages"
            @onChangePageNoRequest="updatePage"
            :currentPage="
              $route.params.pageNo === undefined
                ? currentPage
                : parseInt($route.params.pageNo)
            "
          ></pagination-buttons>
        </div>
      </div>
    </div>
  </layout-default>
</template>

<script>
import LayoutDefault from "../../components/organisms/LayoutDefault/LayoutDefault.vue";
import PaginationButtons from "../../components/atoms/PaginationButtons/PaginationButtons.vue";
// import FilterListCategoryAndSubcategories from "../../components/atoms/Filter/FilterListCategoryAndSubcategories.vue";
// import FilterListTags from "../../components/atoms/Filter/FilterListTags.vue";
// import FilterListSize from "../../components/atoms/Filter/FilterListSize.vue";
import FilterBar from "../../components/atoms/Filter/FilterBar.vue";
import Grid from "../../components/molecules/Layout/Grid.vue";
import List from "../../components/molecules/Layout/List.vue";
import BasicSelectBox from "../../components/atoms/FormInput/BasicSelectBox.vue";
import ChangeLayoutButtons from "../../components/atoms/Button/ButtonDouble.vue";
import BasicInputText from "../../components/atoms/FormInput/BasicInputText.vue";
import Breadcrumb from "../../components/atoms/Breadcrumb/Breadcrumb.vue";
import BasicInputSearch from "../../components/atoms/FormInput/BasicInputSearch.vue";
import FilterTitle from "../../components/atoms/Filter/FilterTitle.vue";
import ButtonFilled from "../../components/atoms/Button/ButtonFilled.vue";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
import { products } from "../../data/auctions.json";
// import { tags } from "../../data/tags.json";
// import { categories } from "../../data/productCategories.json";
// import { dimensions } from "../../data/dimensions.json";
import { getAllProductsAndVariants } from "../../composables/manageProducts";
import { fetchVendors } from "../../composables/manageVendors";

export default {
  beforeCreate() {
    document.title = "Products - viabrera";
  },
  mounted() {
    this.$store.commit("setLocation", [{ title: this.$t('navigation.shop'), location: "/shop" }]);
    // Get the query string parameter from the URL
    this.appliedCategory = this.$route.query.categoryId != -1 ? this.$route.query.categoryId : null;
    this.searchQuery = this.$route.query.search || null;
    this.getProducts();
  },
  created(){
    this.loadBrandOptions();
  },
  components: {
    LayoutDefault,
    PaginationButtons,
    // FilterListCategoryAndSubcategories,
    // FilterListTags,
    // FilterListSize,
    FilterBar,
    Grid,
    List,
    BasicSelectBox,
    ChangeLayoutButtons,
    VueSlider,
    Breadcrumb,
    FilterTitle,
    BasicInputSearch,
    ButtonFilled,
    BasicInputText,
  },
  data() {
    return {
      itemsPerPage: 2,
      currentPage: 1,
      auctions: products, // alias items
      test: "",
      searchQuery: null,
      sortOptions: [
        { name: this.$t('shop.sortByLatest'), value: 'newest' },
      ],
      selectedSortOption: "",
      layout: true,
      // tags,
      // dimensions,
      rangeSliderValue: [0.0, 2000.0],
      appliedRangeSliderValue: [0.0, 2000.0],
      numberOfItems: 0,
      showFilterMenu: false,
      totalPages: 0,
      products: [],
      appliedCategory: "",
      conditionOptions: [
        { name: this.$t('common.new'), value: 'new' },
        { name: this.$t('common.used'), value: 'used' },
      ],
      selectedCondition: null,
      appliedCondition: null,
      brandOptions: [],
      selectedBrand: null,
      appliedBrand: null,
    };
  },
  watch:{
    '$route.query.categoryId'(newVal) {
      this.appliedCategory = newVal;
    },
    '$route.query.search'(newVal) {
      this.searchQuery = newVal;
    },
    currentPage () {
      this.getProducts();
    },
    appliedRangeSliderValue() {
      this.currentPage = 1;
      this.getProducts();
    },
    appliedCondition() {
      this.currentPage = 1;
      this.getProducts();
    },
    appliedCategory() {
      this.currentPage = 1;
      this.getProducts();
    },
    appliedBrand() {
      this.currentPage = 1;
      this.getProducts();
    },
    selectedSortOption() {
      this.currentPage = 1;
      this.getProducts();
    },
    searchQuery() {
      this.currentPage = 1;
      this.$router.push({
        query: {
          ...this.$route.query, // keep existing query parameters
          search: this.searchQuery || "", // add or update "search"
        },
      });
      this.getProducts();
    }
  },
  methods: {
    limitAuctionsPerPage() {
      let nextItems =
        (this.currentPage - 1) * this.itemsPerPage + this.itemsPerPage;

      return this.auctions.slice(
        (this.currentPage - 1) * this.itemsPerPage,
        nextItems > this.numberOfItems ? this.numberOfItems : nextItems
      );
    },
    updatePage(pageNo) {
      this.currentPage = pageNo;
    },
    async getProducts() {
      let res = await getAllProductsAndVariants({
        limit: this.itemsPerPage,
        page: this.currentPage,
        minPrice: this.appliedRangeSliderValue[0],
        maxPrice: this.appliedRangeSliderValue[1],
        condition: this.appliedCondition && this.appliedCondition != '-1' ? [this.appliedCondition] : [],
        brand: this.appliedBrand && this.appliedBrand != '-1' ? [this.appliedBrand] : [],
        sortBy: this.selectedSortOption && this.selectedSortOption != '-1' ? this.selectedSortOption : null,
        k: this.searchQuery != "" ? this.searchQuery : null,
        categoryId: this.appliedCategory && this.appliedCategory != '-1' ? this.appliedCategory : null,
      });

      this.numberOfItems = res?.totElements || 0;
      this.totalPages = res?.totPages || 0;
      this.products = res?.varianti || [];
    },
    applyConditionFilter() {
      this.appliedCondition = this.selectedCondition;
    },
    applyPriceRangeFilter() {
      this.appliedRangeSliderValue = this.rangeSliderValue;
    },
    applyBrandFilter() {
      this.appliedBrand = this.selectedBrand;
    },
    async loadBrandOptions() {
      try {
        const vendors = await fetchVendors();
        this.brandOptions = Array.isArray(vendors)
          ? vendors
              .filter((vendor) => vendor?.name)
              .map((vendor) => ({
                name: vendor.name,
                value: vendor.name,
              }))
          : [];
      } catch (error) {
        console.error("Failed to load master craftsmen list", error);
        this.brandOptions = [];
      }
    }
  },
  computed: {
    filterMenuState() {
      return this.$store.state.app.currentActiveModal === "filter"
        ? this.$store.state.app.currentActiveModal
        : false;
    },
  },
};
</script>
<style>
.vue-slider-process,
.vue-slider-dot-tooltip-inner {
  background-color: var(--primary-color);
  border-color: var(--primary-color);
}
</style>
<style scoped="scoped">
.brand-dropdown-wrapper,
.condition-dropdown-wrapper {
  border: 1px solid #e6e6e6 !important;
  border-radius: 30px;
  padding: 0px 10px;
  width: 250px;
}
.brand-dropdown-wrapper select,
.condition-dropdown-wrapper select {
  padding: 10px 0;
  border: none;
  width: 100%;
}
.sorting select {
  width: 250px;
}

.sorting {
  border: 1px solid #e6e6e6 !important;
  border-radius: 30px;
  padding: 0px 10px;
}
.btn-link {
  color: var(--primary-color);
  background: none !important;
}
.title {
  margin-top: 25px;
  font-size: 22px !important;
  width: 80%;
}
.shop-title {
  font-weight: 600 !important;
}
.filter-col {
  padding: 0px 15px;
  order: 1;
}
.list-search {
  border: 1px solid #e6e6e6 !important;
}
.input-color,
.input-condition,
.search-field.radius.border.input-condition {
  border-radius: 5px !important;
  border-color: #aaa;
  transition: border-color 0.25s ease-in-out;
}
.shop-grid {
  order: 2;
}
.shop-container {
  padding-top: 50px;
  padding-bottom: 50px;
}
.breadcrumb {
  padding-top: 40px;
}
.shop-breadcrumb {
  padding-bottom: 40px;
}
ul {
  padding: 0px;
}
.Minicart_button {
  width: 100px !important;
}
.filter-btn {
  margin-top: 5px;
  padding: 7px 25px !important;
}
.shop-slider {
  width: 240px;
}
.pagination-shop {
  margin-bottom: 70px;
  margin-top: 70px;
}
.price-font {
  font-size: 0.8751em;
}
.filter-search-shop,
.color-select-shop,
.condition-select-shop,
.brand-select-shop,
.filter-range-shop,
.size-select-shop,
.tags-shop,
.categories-shop {
  margin-bottom: 15px;
}
.color-filter,
.condition-filter {
  border-radius: 15px !important;
}

:deep(.Counter .col-3) {
  padding: 6px 9px !important;
}
@media (max-width: 767.98px) {
  :deep(.left-side) {
    width: 100%;
  }

  .filter-mobile {
    display: block !important;
    position: fixed;
    height: 100%;
    left: 0;
    top: 0;
    width: fit-content;
    z-index: 9999;
    background: white;
    padding-top: 50px !important;
    overflow: auto;
    transform: translateX(-100%);
    transition: transform 0.25s ease-in-out;
  }
  .filter-mobile.active {
    transform: translateX(0);
  }
  .pagination-shop {
    justify-content: flex-start !important;
    padding: 0 10px !important;
  }
  .filter-bar-shop {
    padding: 0 10px;
  }
  .shop-breadcrumb {
    margin-bottom: 20px;
  }
  .breadcrumb {
    padding-top: 10px;
    margin-bottom: 0;
  }
  .filter-col {
    padding: 0 0 0 24px;
    order: 2;
  }
  .shop-grid {
    order: 1;
  }
  .shop-container {
    padding: 0;
  }
  .shop-breadcrumb {
    padding: 5px 10px;
  }
  :deep(.Counter .col-3) {
    padding: 7px 0px !important;
  }
}

@media (min-width: 768px) and (max-width: 1024px) {
  .shop-slider {
    width: 160px !important;
  }
}
</style>
